import React, { useRef, useState } from 'react';

import axios, { Canceler } from 'axios';
import useCancel from '../Hooks/CancelFetch';
import Backend from '../../utils/Backend';
import { validateFormRequest } from '../../helper/validators';
import { toast } from 'react-toastify';
import { SingleSelect } from '../Selectors';

import Spinner from '../Spinner';
import IOption from '../../interfaces/IOption';

import styles from './styles.module.scss'
import useMobile from '../Hooks/Mobile';
import eventGTM from '../../lib/gtag';

const formTypes: IOption[] = [
  { value: 'advisory_fleet_transition', label: 'Fleet Transition' },
  { value: 'advisory_charging_solutions', label: 'Charging Solutions' },
  { value: 'advisory_energy_management', label: 'Energy Management' },
  { value: 'advisory_emobility_education', label: 'E-Mobility Education' },
  { value: 'advisory_telematics', label: 'Telematics' },
]

export default function Form({ header = "Let's Talk" })  {
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState<string>("");
  const [message, setMessage] = useState("");

  const [formType, setFormType] = useState<IOption | null>(null)

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  
  const screen1440 = useMobile(1440)

  const dataHolderRef = useRef<HTMLDivElement>(null);

  const submitCancelRef = useRef<Canceler>()

  useCancel(submitCancelRef.current)
  const sendRequest = () => {
    eventGTM('clickedOnSubmitForm')

    if (!formType) {
      toast.error("Please, select Request Type")
      return
    }

    if (!validateFormRequest(name, email, phone, message)) return
    
    if (company.length === 0) {
      toast.error("Company name is required")
      return
    }

    setLoading(true);

    const form_type = formType.value as string;

    const { promise, cancel } = Backend.formRequest(name, email, message, form_type, phone, company)
    
    submitCancelRef.current = cancel;

    promise.then((res) => {
      if (res.status === 201) {
        if (dataHolderRef && dataHolderRef.current) {
          dataHolderRef.current.classList.toggle(styles.disappear);
        }
        setTimeout(() => {
          setSubmitted(true);
        }, 750)
      }
    })
    .catch((err) => {
      if (axios.isCancel(err)) return;
      
      toast.error("Sorry, internal server error occured. Please, try again later.")
      setLoading(false)
    }); 
  }

  return (
    <div className={styles.askQuestionHolder}>
      <h1 className={styles.header}>{ header }</h1>
      <p className={styles.subHeader}>
        {
          submitted 
          ? "Thanks! You'll hear from us soon."
          : "Ask us anything and our team of experts will get you the correct answer."
        } 
      </p>
      
      {
        !submitted &&
        <>
          <div className={styles.dataHolder} ref={dataHolderRef}>
            <SingleSelect 
              value={formType}
              placeholder='Type of Enquiry *'
              options={formTypes} 
              onChange={(value: any) => setFormType(value)}
              screen1440={screen1440}
              onClick={() => eventGTM('clickedOnTypeOfEnquiry')}
            />

            <div className={`${styles.contactUsInput} transparent-input`}>
              <div>
                <input 
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  placeholder="Your Name *"
                  onClick={() => eventGTM('clickedOnYourName')}
                />
              </div>
            </div> 

            <div className={`${styles.contactUsInput} transparent-input`}>
              <div>
                <input 
                  type="text"
                  value={company}
                  onChange={e => setCompany(e.target.value)}
                  placeholder="Company *"
                  onClick={() => eventGTM('clickedOnCompany')}
                />
              </div>
            </div>

            <div className={`${styles.contactUsInput} transparent-input`}>
              <div>
                <input 
                  type="text"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Email *"
                  onClick={() => eventGTM('clickedOnEmail')}
                />
              </div>
            </div> 

            <div className={`${styles.contactUsInput} transparent-input`}>
              <div>
                <input 
                  type="text"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', ''))
                  }}
                  placeholder='Phone Number *'
                  onClick={() => eventGTM('clickedOnPhoneNumber')}
                />
              </div>
            </div>
            
            <div className={`${styles.contactUsInput} transparent-input`}>
              <div>
                <textarea
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  placeholder="Question *"
                  maxLength={1024}
                  onClick={() => eventGTM('clickedOnQuestionInput')}
                />
              </div>
            </div> 


            <div className={`${styles.submitButton} button-holder`}>
              { loading ? 
                <div className={`${styles.spinnerHolder} spinner-holder`}><Spinner /></div> :
                <button className="blue-button" onClick={sendRequest}>Send</button>
              }
            </div>
          </div>  
        </>
      }
    </div>
  )
};
